import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';

export default function CallBackPage() {
  const { isLoading } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      navigate('/');
    }
  }, [isLoading, navigate]);

  return <div>Loading...</div>;
}
